// Role words come from the schema enum (the only list); this file adds the labels people read.
import { Role } from '@/api/schemas'

export const ROLE = Role.enum

export const ROLE_LABEL: Record<Role, string> = {
  admin: 'Admin',
  campaign_manager: 'Campaign manager',
  approver: 'Approver',
  analyst: 'Analyst (read only)',
}

/** What each role may do, in a few words (the Users page's role list). */
export const ROLE_HINT: Record<Role, string> = {
  admin: 'everything, incl. users, settings and removing from the suppression list',
  campaign_manager: 'channels, audiences, workflows, campaigns; start and pause',
  approver: 'approves campaigns (never their own)',
  analyst: 'reads everything, changes nothing',
}
